import Layout from "../components/Layout";
import React, {useEffect, useRef, useState} from "react";
import {useSearchParams} from "react-router-dom";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import BootstrapModal from "../components/BootstrapModal";
import {Field, Form, Formik,ErrorMessage} from "formik";
import TextField from "../components/TextField";
import FormSelect from "../components/FormSelect";
import {Calendar} from "primereact/calendar";
import {useSelector} from "react-redux";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Toast} from "primereact/toast";
import * as Yup from "yup";

const IDPDetails = () => {
    const primeToast = useRef(null)
    const [searchParams] = useSearchParams()
    const {user} = useSelector((state) => state.auth)
    const [iDPEmployeeDetails, setIDPEmployeeDetails] = useState([])
    const [modal, setModal] = useState(false)
    const [modalSkill, setModalSkill] = useState(false)
    const [assessmentList, setAssessmentList] = useState([])
    const [competencyList, setCompetencyList] = useState([])
    const [matrixTitleList, setMatrixTitleList] = useState([])
    const [selectedOptionList, setSelectedOptionList] = useState([])
    const [iDPOpinionList, setGetIDPOpinionList] = useState([])
    const [iDPEmployeeGridData, setIDPEmployeeGridData] = useState([])
    const [date3, setDate3] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [start] = useState(0);
    const [empId,setEmpid] = useState(0);
    const [isCompetency, setIsCompetency] = useState(false)
    const [defaultCoreValues, setDefaultCoreValues] = useState(null);
    const [matrixTitleValues, setMatrixTitleValues] = useState(null);
    const [defaultOpinion, setDefaultOpinion] = useState(null);
    const [valueType, setValueType] = useState(null);
    const [defaultCompetencyValues, setDefaultCompetencyValues] = useState(null);
    const [modalTitle, setModalTitle] = useState('');

    useEffect(() => {
        GetIDPOpinionList();     
        if (searchParams.has("employeeId")) {
            const employeeId = atob(searchParams.get("employeeId"));            
            setEmpid(employeeId);
            GetIDPEmployeeGridData(employeeId);
            GetIDPEmployeeDetails(employeeId);
        }
    }, [])

    const onHide = e => {
        setModal(!modal)
    }

    const onHideSkillModal = e => {
        setModalSkill(!modalSkill)
    }

    const GetIDPEmployeeGridData = id =>{
        var data = {
            RegisterID: parseInt(id),
            QuarterID: user.quarterID
        };
        axios.post(BASE_URL+"/api/idp/GetIDPEmployeeGridData", JSON.stringify(data))
            .then(response=>{
                setIDPEmployeeGridData(response.data)
            })
            .catch(console.log)
    }

    ///api/idp/GetIDPOpinionList
    const GetIDPOpinionList = () => {
        axios.get(BASE_URL + "/api/idp/GetIDPOpinionList")
            .then(response => {
                setGetIDPOpinionList(response.data)

                if(response.data.length > 0)
                   setDefaultOpinion(response.data[0].idpOpinionID);
            })
            .catch(console.error)
    }

    ///api/idp/GetIDPEmployeeDetails/{id}
    const GetIDPEmployeeDetails = (id) => {
        axios.get(BASE_URL + `/api/idp/GetIDPEmployeeDetails/${id}`)
            .then(response => {
                //console.log(response.data)
                setAssessmentList(response.data.filter(item => item.type === "Assesment"));
                setCompetencyList(response.data.filter(item => item.type === "Competency"));
                setMatrixTitleList(response.data.filter(item => item.type === "MatrixTitle"));
                setIDPEmployeeDetails(response.data);
                const _CoreValues = response.data.filter(item => item.type === "Assesment");
                const _CompetencyValues = response.data.filter(item => item.type === "Competency");
                const _MatrixValues = response.data.filter(item => item.type === "MatrixTitle");
                
                if(_CoreValues.length > 0)
                    setDefaultCoreValues(_CoreValues[0].typeID);

                if(_CompetencyValues.length > 0)
                    setDefaultCompetencyValues(_CompetencyValues[0].typeID);

                if(_MatrixValues.length > 0)
                    setMatrixTitleValues(_MatrixValues[0].typeID);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const downloadReportData = () => {
        var _employeeID = atob(searchParams.get("employeeId"));
        window.open("https://apps.bitopibd.com/bimobapps/PMSReport/IDPReport?SearchStr="+btoa("RegisterID=" + _employeeID));
    }

    const validationMatrix = Yup.object({        
        AssestmentID: Yup.number().typeError('Please Select Matrix Title..!').integer().min(0,'Please Select Matrix Title..!').required("This field is required"),
        IdpOpinionID: Yup.number().typeError('Please Select Your Opinion..!').integer().min(0,'Please Select Your Opinion..!').required("This field is required"),
        Status: Yup.string().min(1).required("Please Select Your Status..!"),
        //MatrixActionFromTime: Yup.string().required("This field is required"),
        //basicTo: Yup.string().required("This field is required"),
    })

    return (
        <Layout>
            <Toast ref={primeToast}/>
            <BootstrapModal headerText={modalTitle} size={60} visible={modal} onHide={onHide}>
                <Formik
                    validationSchema={validationMatrix} initialValues={{AssestmentID: 0, IdpOpinionID: 0,ActionFromTime:'',ActiveToTime:'',
                        Status:'',SupervisorComments:'',EmployeeComments:'',ExceptionalScoreComments:'',
                        RegisterID:'',AddedBy:'',QuarterID:''
                    }}
                    onSubmit={(data,{resetForm})=>{
                        //const fromDate = new Date(date3)
                      data.ActionFromTime = date3.toISOString().split('T')[0];
                      data.ActiveToTime = toDate.toISOString().split('T')[0];
                      data.RegisterID = iDPEmployeeDetails.length !== 0 ? iDPEmployeeDetails[0].registerID : "";
                      data.AddedBy = user.registerID.toString();
                      data.QuarterID = user.quarterID ?? "-1";
                      data.IdpType = valueType.toString();

                      console.log(JSON.stringify(data))
                      //return false;
                        axios.post(BASE_URL+"/api/idp/SaveIDPInformationWithMatrix",JSON.stringify(data))
                            .then(response=>{
                                console.log(response)
                                if (response.status === 200){
                                    setModal(!modal)
                                    resetForm()
                                    GetIDPEmployeeGridData(empId)
                                    primeToast.current.show({ severity: 'success', summary: 'success', detail: 'Data Save successfully', life: 3000 });
                                }

                            })
                            .catch(e=>console.log(e))
                    }}>
                    {formik =>
                        (<>
                            <Form>
                                <Field  type="hidden" name="RegisterID" value={iDPEmployeeDetails.length !== 0 ? iDPEmployeeDetails[0].registerID : ""}/>
                                <Field  type="hidden" name="AddedBy" value={user.registerID}/>
                                <Field  type="hidden" name="QuarterID" value={user.quarterID ?? "-1"}/>

                                <div className="row">
                                    <div className="col-md-6">                                        
                                        <Field as="select" id="AssestmentID"  name="AssestmentID" className='form-select'> 
                                                    <option value={-1}>{"Select an Option"}</option>
                                                    {selectedOptionList.map(option=>(
                                                        <option key={option.value} value={option.typeID}>{option.typeName}</option>
                                                    ))}
                                                </Field>
                                        <ErrorMessage name="AssestmentID" component='div' className='text-danger'/>
                                    </div>
                                    <div className="col-md-6">
                                        <Field as="select" id="IdpOpinionID"  name="IdpOpinionID" className='form-select'> 
                                                    <option value={-1}>{"Select an Opinion"}</option>
                                                    {iDPOpinionList.map(option=>(
                                                        <option key={option.idpOpinionID} value={option.idpOpinionID}>{option.title}</option>
                                                    ))}
                                                </Field>
                                        <ErrorMessage name="IdpOpinionID" component='div' className='text-danger'/>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-md-6">
                                        <label htmlFor="icon">From Date</label>
                                        <Calendar id="basic" name="ActionFromTime"
                                                  value={date3} onChange={(e) => setDate3(e.value)}
                                                  showIcon/>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="icon">To Date</label>
                                        <Calendar id="basic"
                                                  name="ActiveToTime"
                                                  value={toDate}
                                                  onChange={(e) => setToDate(e.value)}
                                                  showIcon/>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                         <label>Status</label>
                                         <Field as="select" id="Status"  name="Status" className='form-select'> 
                                            <option value={""}>{"Select Status"}</option>
                                            <option value={"New"}>{"New"}</option>
                                            <option value={"Completed"}>{"Completed"}</option>
                                            <option value={"Postpone"}>{"Postpone"}</option>
                                        </Field>
                                        <ErrorMessage name="Status" component='div' className='text-danger'/>
                                    </div>
                                    <div className="col-md-6">
                                        <TextField label={'Supervisor Comments'} type="text" name="SupervisorComments"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <TextField label={'Employee Comments'} type="text" name="EmployeeComments"/>
                                    </div>
                                    <div className="col-md-6">
                                        <TextField label={'Exceptional Score Comments'} type="text"
                                                   name="ExceptionalScoreComments"/>
                                    </div>
                                </div>


                                <button type="submit" className="btn btn-primary"><i class="bi bi-check-lg"></i> Save</button>

                            </Form>
                        </>)}
                </Formik>
            </BootstrapModal>                                                        
            <div className="card mb-3">
                <div className="card-header">
                    <div className="row">
                        <div className="col-10" style={{fontSize:".8rem"}}>
                          <i class="bi bi-person-lines-fill"></i>&nbsp; &nbsp;
                          { iDPEmployeeDetails.length !== 0 ? iDPEmployeeDetails[0].employeeName : ""} <i class="bi bi-chevron-double-right"></i> &nbsp;
                          { iDPEmployeeDetails.length !== 0 ? iDPEmployeeDetails[0].designation : ""} <i class="bi bi-chevron-double-right"></i> &nbsp;
                          { iDPEmployeeDetails.length !== 0 ? iDPEmployeeDetails[0].department : ""}
                        </div>                      
                        <div className="col-2">
                            <button className="btn btn-primary btn-sm float-end" id="btnDownloadData" onClick={downloadReportData}><i class="bi bi-file-earmark-pdf-fill"></i> Download</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-4">
                            <h6><i class="bi bi-shield-fill-check"></i>  Core Values</h6>
                        </div>
                        <div className="col-md-8">
                            {assessmentList.length > 0 ? (
                            <button onClick={() => {
                                setValueType("Assesment");
                                setIsCompetency(false)
                                setModal(!modal)
                                setModalTitle('Add Core Values');
                                setSelectedOptionList(assessmentList);
                            }} className="btn btn-primary btn-sm float-end"><i class="bi bi-check-lg"></i> Add Core Values
                            </button>
                            ) : <></>}
                        </div>

                    </div>

                </div>
                <div className="card-body divIDPDetails">
                    <DataTable value={iDPEmployeeGridData.filter(item=>item.idpType === "Assesment")}  rows={7} first={start}
                               paginatorTemplate=" PageLinks ">
                        <Column field="idpType" header="IdpType" hidden={true}/>
                        <Column field='title' header="Title"/>
                        <Column field='assesmentCompetencyName' header="Assessment Name"/>
                        <Column field='actionFromTime' header="From"/>
                        <Column field='activeToTime' header="To"/>
                        <Column field='status' header="Status"/>
                        <Column field='supervisorComments' header="Supervisor Comments"/>
                        <Column field='employeeComments' header="Employee Comments"/>
                        <Column field='exceptionalScoreComments' header="Exceptional Score Comments"/>
                    </DataTable>
                </div>

            </div>

            <div className="card mt-5">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-4">
                            <h6><i class="bi bi-shield-fill-check"></i> Core Competency</h6>
                        </div>
                        <div className="col-md-8">
                        {competencyList.length > 0 ? (
                            <button onClick={() => {
                                setValueType("Competency");
                                setIsCompetency(true);
                                setModal(!modal);
                                setModalTitle('Add Core Competency');
                                setSelectedOptionList(competencyList);
                            }} className="btn btn-primary btn-sm float-end"><i class="bi bi-check-lg"></i> Add Core Competency
                            </button>
                            ) : <></>}
                        </div>

                    </div>
                </div>

                <div className="card-body divIDPDetails">
                    <DataTable value={iDPEmployeeGridData.filter(item=>item.idpType === "Competency")}  rows={7} first={start}
                               paginatorTemplate=" PageLinks ">
                        <Column field="idpType" header="IdpType" hidden={true}/>
                        <Column field='title' header="Title"/>
                        <Column field='assesmentCompetencyName' header="Competency Name"/>
                        <Column field='actionFromTime' header="From"/>
                        <Column field='activeToTime' header="To"/>
                        <Column field='status' header="Status"/>
                        <Column field='supervisorComments' header="Supervisor Comments"/>
                        <Column field='employeeComments' header="Employee Comments"/>
                        <Column field='exceptionalScoreComments' header="Exceptional Score Comments"/>
                    </DataTable>
                </div>

            </div>
            {/* <div className="card mt-5">
                <div className="card-header">

                    <div className="row">
                        <div className="col-md-4">
                            <h6><i class="bi bi-shield-fill-check"></i> Skill Matrix</h6>
                        </div>
                        <div className="col-md-8">
                        {matrixTitleList.length > 0 ? (
                            <button onClick={() => {
                                setValueType("SkillMatrix");
                                setIsCompetency(true);
                                setModal(!modal);
                                setModalTitle('Add Skill Title');
                                setSelectedOptionList(matrixTitleList);
                            }} className="btn btn-primary btn-sm float-end"><i class="bi bi-check-lg"></i> Add Skill Titles
                            </button>
                            ) : <></>}
                        </div>

                    </div>
                </div>
                    <div className="card-body divIDPDetails">
                        <DataTable value={iDPEmployeeGridData.filter(item=>item.idpType === "SkillMatrix")}  rows={7} first={start}
                                paginatorTemplate=" PageLinks ">
                            <Column field="idpType" header="IdpType" hidden={true}/>
                            <Column field='title' header="Title"/>
                            <Column field='assesmentCompetencyName' header="Skill Titles"/>
                            <Column field='actionFromTime' header="From"/>
                            <Column field='activeToTime' header="To"/>
                            <Column field='status' header="Status"/>
                            <Column field='supervisorComments' header="Supervisor Comments"/>
                            <Column field='employeeComments' header="Employee Comments"/>
                            <Column field='exceptionalScoreComments' header="Exceptional Score Comments"/>
                        </DataTable>
                    </div>
                </div> */}

                <div className="card mt-5">
                <div className="card-header">

                    <div className="row">
                        <div className="col-md-4">
                            <h6><i class="bi bi-shield-fill-check"></i> Skill Matrix</h6>
                        </div>
                        <div className="col-md-8">                        
                            <button onClick={() => {
                                setValueType("SkillMatrix");
                                setIsCompetency(true);
                                setModal(!modal);
                                setModalTitle('Add Skill Title');
                                setSelectedOptionList(matrixTitleList);
                            }} className="btn btn-primary btn-sm float-end"><i class="bi bi-check-lg"></i> Add Skill Titles
                            </button>                            
                        </div>

                    </div>
                </div>
                    <div className="card-body divIDPDetails">
                        <DataTable value={iDPEmployeeGridData.filter(item=>item.idpType === "SkillMatrix")}  rows={7} first={start}
                                paginatorTemplate=" PageLinks ">
                            <Column field="idpType" header="IdpType" hidden={true}/>
                            <Column field='title' header="Title"/>
                            <Column field='assesmentCompetencyName' header="Skill Titles"/>
                            <Column field='actionFromTime' header="From"/>
                            <Column field='activeToTime' header="To"/>
                            <Column field='status' header="Status"/>
                            <Column field='supervisorComments' header="Supervisor Comments"/>
                            <Column field='employeeComments' header="Employee Comments"/>
                            <Column field='exceptionalScoreComments' header="Exceptional Score Comments"/>
                        </DataTable>
                    </div>
                </div> 
        </Layout>
    )
}

export default IDPDetails